import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

export interface ActualSizeProps {
  children: React.ReactNode;
}

export function ActualSize({ children }: ActualSizeProps) {
  return <Wrapper>{children}</Wrapper>;
}

const Wrapper = styled.div`
  margin: 0 0 8px;
  background-color: ${vars.v3Color.staticWhite};
  padding: 20px 16px 40px;
`;

const Caution = styled.p`
  color: ${vars.color.gray400};
  text-align: left;
  line-height: 16.8px;
`;

ActualSize.Caution = Caution;
